import _ from 'lodash';
import { createSelector } from 'reselect';

import { StoreState } from '../../../../redux/reducers/store.types';
import { StringMap } from '../../../../types/system';
import {
  FileUploadFailed,
  FileUploadStatusType,
} from '../operation-groups.types';

import { UploadOperationsState } from './upload-operations.reducer';

export const getOperationsState = (state: StoreState): UploadOperationsState =>
  state.operationPanel.uploadOperations;

export const getFailedUploadOperationMap = createSelector(
  getOperationsState,
  (state: UploadOperationsState): StringMap<FileUploadFailed> =>
    _.chain(state)
      .values()
      .filter({ type: FileUploadStatusType.Failed })
      .keyBy('clientId')
      .value() as StringMap<FileUploadFailed>,
);

export const getUploadOperationClientIdByFileId = createSelector(
  getOperationsState,
  (state: UploadOperationsState) =>
    _.memoize((fileId: string): string | undefined => {
      const operation = _.chain(state).values().find({ fileId }).value();

      if (!operation) {
        return;
      }

      return operation.clientId;
    }),
);
